import {
    MdHouse,
    MdSchool,
    MdOutlineAccountBalance,
    MdOutlineChromeReaderMode,
    MdOutlineDocumentScanner,
    MdOutlineShoppingBag,
    MdOutlineWarningAmber,
    MdOutlineShoppingCart,
    MdOutlineQrCode2,
    MdOutlineGolfCourse,
    MdOutlineBusinessCenter,
    MdOutlinePaid,
    MdOutlineGroups,
    MdOutlineArticle,
    MdOutlineBallot,
    MdOutlineEmail,
    MdOutlineAccountCircle,
    MdOutlineTableView,
    MdOutlineArtTrack,
    MdOutlineLocalOffer,
    MdOutlinePersonPinCircle,
    MdOutlineWorkspacePremium,
    MdOutlineHomeWork,
    MdOutlineTableChart,
    MdOutlinePushPin,
    MdDraw,
    MdCreditScore,
    MdDocumentScanner,
    MdAreaChart,
    MdMoveUp,
    MdOutlineBuild
} from 'react-icons/md';

const NavIcon = ({ route }) => {

    return (
        <>
            {route === "/" && <MdHouse />}
            {route === "/builder-assessment" && <MdOutlineBuild />}
            {route === "/classes" && <MdSchool />}
            {route === "/classes-real1031" && <MdMoveUp />}
            {route === "/merchone" && <MdOutlineShoppingBag />}
            {route === "/merchone-products" && <MdOutlineShoppingBag />}
            {route === "/merchone-management" && <MdOutlineBallot />}
            {route === "/courtesy-signing-request" && <MdDraw />}
            {route === "/bucksone-balances" && <MdOutlinePaid />}
            {route === "/site-messages" && <MdOutlineWarningAmber />}
            {route === "/sales-toolkit" && <MdOutlineBusinessCenter />}
            {route === "/item-of-the-week" && <MdOutlineChromeReaderMode />}
            {route === "/foreclosure-sales" && <MdOutlineAccountBalance />}
            {route === "/digital-home-portfolios" && <MdOutlineQrCode2 />}
            {route === "/preferred-customers" && <MdOutlineGroups />}
            {route === "/home-page-cards" && <MdOutlineArticle />}
            {route === "/reps-of-the-year" && <MdOutlineWorkspacePremium />}
            {route === "/ecards" && <MdOutlineEmail />}
            {route === "/team-members" && <MdOutlineAccountCircle />}
            {route === "/legal-description-extractor" && <MdOutlineDocumentScanner />}
            {route === "/market-share" && <MdOutlineTableView />}
            {route === "/news-articles" && <MdOutlineArtTrack />}
            {route === "/promo-order-form" && <MdOutlineShoppingCart />}
            {route === "/promo-item-management" && <MdOutlineLocalOffer />}
            {route === "/promo-order-management" && <MdOutlineTableChart />}
            {route === "/promo-order-zones" && <MdOutlinePersonPinCircle />}
            {route === "/offices" && <MdOutlineHomeWork />}
            {route === "/job-postings" && <MdOutlinePushPin />}
            {route === "/community-events" && <MdOutlineGolfCourse />}
            {route === "/reconveyance-management" && <MdCreditScore />}
            {route === "/tpm-dashboard" && <MdDocumentScanner />}
            {route === "/tpm-analytics" && <MdAreaChart />}
        </>
    );
}
export default NavIcon